module.exports = __webpack_public_path__ + "static/media/plat.21fd8fe6.gif";